import schedules from './schedules';
import breaks from './breaks';
import roomView from './roomView';

/**
 * Notes:
 * - Each of these functions return an array of string arrays
 * - In csv terms, each array in the array represents a row
 */
export default {
  schedules,
  breaks,
  roomView
};
